// Libs
import React from 'react';
import { Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

// Constants
import {
  emptyKitsMessage,
  emptyKitsButtonTitle,
} from '../../../constants/kits';

// Styles
import { useStyles } from './EmptyKitsScreenStyles';

const EmptyKitsScreen = ({
  message = emptyKitsMessage,
  withRedirectButton = true,
}) => {
  const navigate = useNavigate();
  const { classes } = useStyles();
  return (
    <div className={classes.emptyKitsContainer}>
      <Typography
        className={classes.emptyKitsBook}
        variant="h1"
        textAlign="center">
        {message}
      </Typography>
      {withRedirectButton && (
        <Button
          data-testid="empty-kits-redirect-button"
          variant="contained"
          onClick={() => {
            navigate('/order-history');
          }}
          className={classes.emptyKitsButton}>
          {emptyKitsButtonTitle}
        </Button>
      )}
    </div>
  );
};

export default EmptyKitsScreen;
